import React, { Component } from "react";
import $ from "jquery";
import { NavLink, withRouter } from "react-router-dom";
import "./nav.css";
import { connect } from "react-redux";
import { changeLanguage } from "../../../store/actions/changeLanguageAction";
import "./nav.css";
import {
  fetchDistrictList,
  fetchSettings
} from "../../../store/actions/globalActions";
import { host } from "../../../utils/globals";
import { SETTINGS_API_URL } from "../../../store/constants/urls";
import { removeOtherActive, getSettingValue } from "../../../utils/helpers";

class Nav extends Component {
  state = {
    language: "English",
    districtImg: "",
    MostEffecteddistrictImg: "",
    queryText: "",
    defaultModeratelyAffectedImg: "/img/moderately-affected-districts.png",
    defaultMostAffectedImg: "/img/most-affected-districts.png",
    subscriptionUrl: "https://hrrpnepal.us12.list-manage.com/subscribe/post?u=e625790c6bdf9419f624ca776&id=012c350bc0'",
  };

  componentDidMount() {
    removeOtherActive();
    let { isFetched } = this.props.districtList;
    let { settings } = this.props;
    !isFetched && this.props.dispatch(fetchDistrictList());
    let url = `${SETTINGS_API_URL}`;
      fetch(url)
        .then(res => res.json())
        .then(data => {
              this.setState({
                'subscriptionUrl' : data.data[5]['subscription_url'],
              });
    });
    // if (!settings.isFetched) this.props.dispatch(fetchSettings());
  




    $(function () {
      $(document).scroll(function () {
        var $nav = $(".navbar-fixed-top");
        if (window.location.pathname === "/") {
          $nav.toggleClass("scrolled", $(this).scrollTop() > $nav.height());
        }

        if ($(".navbar-collapse.collapse").hasClass("in")) {
          $(".navbar-collapse.collapse").removeClass("in");
        }
      });

      let container = $("#bs-example-navbar-collapse-1");

      $("body").on("click", function (e) {
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $(".navbar-collapse.collapse").removeClass("in");
        }
      });
    });
    $(function () {
      var header = $(".header");

      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 26) {
          header.addClass("my-scrolled");
        } else {
          header.removeClass("my-scrolled");
        }
      });
    });

    let toggleAnchor = document.getElementsByClassName("custom-toggle");

    for (let i = 0; i < toggleAnchor.length; i++) {
      toggleAnchor[i].addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.target.closest(".side-dropdown").classList.toggle("open");
      });
    }

    $(document).on("click", function (e) {
      let container = $(".search");
      if (
        container.is(e.target) === false &&
        container.has(e.target).length === 0
      ) {
        $(".search").removeClass("active");
      }
    });
  }

  changeLang = e => {
    if (e.target.value !== "English") {
      this.setState({
        language: "Nepali"
      });
      this.props.dispatch(changeLanguage(false));
    } else {
      this.setState({
        language: "English"
      });
      this.props.dispatch(changeLanguage(true));
    }
  };

  searchClick = e => {
    e.preventDefault();
    e.target.closest(".search").classList.add("active");
  };

  removeActive = e => {
    e.target.closest(".search").classList.remove("active");
  };

  changeDistrictImg = (img, mostEffected) => {
    mostEffected
      ? this.setState({ MostEffecteddistrictImg: img })
      : this.setState({ districtImg: img });
  };

  searchNews = e => {
    const { queryText } = this.state;
    const { history } = this.props;
    const path = `/search?query=${queryText}`;
    if (e.keyCode === 13) {
      history.push(path, { searchText: queryText });
      this.setState({ queryText: "" });
    }
  };

  onSearchChange = e => {
    e.preventDefault();
    this.setState({
      queryText: e.target.value
    });
  };

  render() {
    const { addClass, settings } = this.props;
    console.log(settings);
    let { districtList } = this.props.districtList;
    let { language, districtImg, MostEffecteddistrictImg, defaultModeratelyAffectedImg,defaultMostAffectedImg } = this.state;
    let {subscriptionUrl} = this.state;
    // let subscriptionUrl = getSettingValue('subscription_url', settings) ||
    // 'https://hrrpnepal.us12.list-manage.com/subscribe/post?u=e625790c6bdf9419f624ca776&id=012c350bc0';

    // 'https://hrrpnepal.us12.list-manage.com/subscribe/post?u=e625790c6bdf9419f624ca776&id=012c350bc0';
    // 'https://asdf.sadfcom';
    return (
      <React.Fragment>
        <section id="social-header">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 text-right">
                <ul className="list-inline list-unstyled">
                  <li>Follow us at:</li>
                  <li>
                    <a
                      href="https://www.facebook.com/HRRPNepal/"
                      target="_target"
                    >
                      <i className="fa fa-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://flipboard.com/@HRRP" target="_blank">
                      <img src="/img/flipboard.svg" alt="" />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/HRRP_Nepal" target="_blank">
                      <i className="fa fa-twitter" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.flickr.com/photos/hrrp"
                      target="_blank"
                    >
                      <i className="fa fa-flickr" />
                    </a>
                  </li>
                  <li>
                    <a href={subscriptionUrl} target="_blank">Subscribe</a>
                  </li>
                  <li>
                 
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix" />
        <section id="logo-search">
          <div className="container">
            <div className="row">
              <div className="col-xs-6">
                <figure>
                  <NavLink to="/">
                    <img
                      src="/img/logo-new_.svg"
                      alt="hrrp reconstruction"
                      className="img-responsive"
                    />
                    {/* <img src="/img/logo.svg" alt="" className="img-responsive hidden-xs hidden-md hidden-lg" /> */}
                  </NavLink>
                </figure>
              </div>
              <div className="col-xs-6 text-right">
                <form onSubmit={e => e.preventDefault()} id="nav-search">
                  <i className="fa fa-search" />
                  <input
                    type="search"
                    className="form-control search-box"
                    id="searchField"
                    placeholder="Search ..."
                    value={this.state.queryText}
                    onChange={this.onSearchChange}
                    onKeyUp={this.searchNews}
                  />
                </form>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix" />
        <nav className={`navbar navbar-default ${addClass}`}>
          <div className="container">
            <div className="row">
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#bs-example-navbar-collapse-1"
                  aria-expanded="false"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
                <NavLink
                  className="navbar-brand hidden-sm hidden-md hidden-lg"
                  to="/"
                >
                  <img
                    src="/img/hrrp.svg"
                    alt="hrrp reconstruction"
                    className="img-responsive hidden-sm"
                  />
                  <img
                    src="/img/logo.svg"
                    alt=""
                    className="img-responsive hidden-xs hidden-md hidden-lg"
                  />
                </NavLink>
              </div>

              <div
                className="collapse navbar-collapse"
                id="bs-example-navbar-collapse-1"
              >
                <ul
                  className="nav navbar-nav"
                  data-hover="dropdown"
                  data-anitmations="fadeInDown fadeInRight fadeInUp fadeInLeft"
                  id="topNav"
                >
                  <li>
                    <NavLink to="/" exact activeClassName="active">
                      Home{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about" exact activeClassName="active">
                      About Us{" "}
                    </NavLink>
                  </li>
                  <li className="dropdown">
                    <NavLink
                      to="#"
                      className="dropdown-toggle"
                      // activeClassName="active"
                      data-toggle="dropdown"
                      role="button"
                      aria-expanded="false"
                    >
                      District <span className="caret" />
                    </NavLink>
                    <ul
                      className="list-inline container list-unstyled dropdown-menu dropdownhover-bottom"
                      role="menu"
                    >
                      <div className="col-xs-6">
                        <h1 className="text-danger">most affected</h1>

                        <div className="row">
                          <div className="col-xs-4">
                              <figure>
                                <img
                                  src={
                                    MostEffecteddistrictImg && MostEffecteddistrictImg.length > 0 ?
                                        `${host}${MostEffecteddistrictImg}` :
                                        defaultMostAffectedImg
                                  }
                                  className=""
                                />
                              </figure>
                          </div>

                          <div className="col-xs-8">
                            <ul className="list-unstyled dp-list">
                              {districtList &&
                                districtList.length > 0 &&
                                districtList
                                  .filter(d => d.type === "most-affected")
                                  .map((d, i) => (
                                    <li
                                      key={`most-affected-district-${i}`}
                                      onMouseOver={() =>
                                        this.changeDistrictImg(
                                          d && d.image_file,
                                          "most"
                                        )
                                      }
                                      onMouseOut={() => {
                                        this.changeDistrictImg('','most')
                                      }}
                                    >
                                      <a href={`/district/${d.alias}`}>
                                        {d.name}
                                      </a>
                                    </li>
                                  ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-6">
                        <h1 className="text-primary">moderately affected</h1>

                        <div className="row">
                          <div className="col-xs-4">
                            <figure>
                                <img src={districtImg && districtImg.length > 0 ? host + districtImg : defaultModeratelyAffectedImg}/>
                              </figure>
                          </div>
                          <div className="col-xs-8">
                            <ul className="list-unstyled dp-list">
                              {districtList &&
                                districtList.length > 0 &&
                                districtList
                                  .filter(d => d.type === "less-affected")
                                  .map((d, i) => (
                                    <li
                                      key={`less-affected-districts-${i}`}
                                      onMouseOver={() =>
                                        this.changeDistrictImg(
                                          d && d.image_file
                                        )
                                      }
                                      onMouseOut={() => {
                                        this.changeDistrictImg('')
                                      }}
                                    >
                                      <a href={`/district/${d.alias}`}>
                                        {d.name}
                                      </a>
                                    </li>
                                  ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </li>
                  <li>
                    <NavLink
                      to="/maps-infographics"
                      exact
                      activeClassName="active"
                    >
                      Maps & Infographics
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/hrrp-reference-library"
                      exact
                      activeClassName="active"
                    >
                      HRRP Reference Library
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/faq" exact activeClassName="active">
                      FAQ's
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact" exact activeClassName="active">
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    settings: state.settings,
    districtList: state.districtList,
    isEnglish: state.changeLanguage.isEnglish
  };
};

export default connect(mapStateToProps)(withRouter(Nav));
